import {createFileRoute} from '@tanstack/react-router';
import {AppRedirectPage} from '../pages/login/AppRedirectPage';

export const Route = createFileRoute('/app')({
  component: AppRedirectPage,
});
